import Vue from 'vue'

import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BIconArrowLeft,
  BIconArrowLeftRight,
  BIconArrowLeftShort,
  BIconArrowRepeat,
  BIconArrowRightShort,
  BIconBoxArrowUpRight,
  BIconBuilding,
  BIconCalendar2EventFill,
  BIconCart3,
  BIconCheck,
  BIconCheckCircle,
  BIconCheckCircleFill,
  BIconChevronDown,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconDownload,
  BIconEnvelopeFill,
  BIconExclamationCircle,
  BIconExclamationCircleFill,
  BIconExclamationTriangle,
  BIconExclamationTriangleFill,
  BIconFileEarmarkTextFill,
  BIconFilePersonFill,
  BIconFiles,
  BIconFolder2Open,
  BIconFullscreen,
  BIconGear,
  BIconGeoAlt,
  BIconGeoAltFill,
  BIconGraphUp,
  BIconGridFill,
  BIconHash,
  BIconInfoCircle,
  BIconLayersFill,
  BIconListUl,
  BIconPencil,
  BIconPerson,
  BIconPlus,
  BIconQuestionSquareFill,
  BIconSearch,
  BIconTelephone,
  BIconTelephoneFill,
  BIconTrash,
  BIconTriangleFill,
  BIconTruck,
  BIconX,
  BIconXCircle,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupText,
  BLink,
  BModal,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BNavbarToggle,
  BNavItem,
  BNavItemDropdown,
  BPagination,
  BPopover,
  BRow,
  BSidebar,
  BTab,
  BTable,
  BTabs,
  VBPopover,
  VBToggle,
  VBTooltip
} from 'bootstrap-vue'

Vue.component('b-container', BContainer)
Vue.component('b-row', BRow)
Vue.component('b-col', BCol)
Vue.component('b-navbar', BNavbar)
Vue.component('b-navbar-brand', BNavbarBrand)
Vue.component('b-navbar-toggle', BNavbarToggle)
Vue.directive('b-toggle', VBToggle)
Vue.directive('b-popover', VBPopover)
Vue.directive('b-tooltip', VBTooltip)
Vue.component('b-navbar-nav', BNavbarNav)
Vue.component('b-button', BButton)
Vue.component('b-collapse', BCollapse)
Vue.component('b-nav-item', BNavItem)
Vue.component('b-nav-item-dropdown', BNavItemDropdown)
Vue.component('b-dropdown', BDropdown)
Vue.component('b-dropdown-item', BDropdownItem)
Vue.component('b-img', BImg)
Vue.component('b-badge', BBadge)
Vue.component('b-modal', BModal)
Vue.directive('b-modal', BModal)
Vue.component('b-card', BCard)
Vue.component('b-card-header', BCardHeader)
Vue.component('b-card-body', BCardBody)
Vue.component('b-table', BTable)
Vue.component('b-link', BLink)
Vue.component('b-card-title', BCardTitle)
Vue.component('b-card-text', BCardText)
Vue.component('b-form', BForm)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-radio-group', BFormRadioGroup)
Vue.component('b-form-radio', BFormRadio)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-input-group', BInputGroup)
Vue.component('b-input-group-text', BInputGroupText)
Vue.component('b-input-group-prepend', BInputGroupPrepend)
Vue.component('b-sidebar', BSidebar)
Vue.component('b-form-input', BFormInput)
Vue.component('b-tab', BTab)
Vue.component('b-tabs', BTabs)
Vue.component('b-pagination', BPagination)
Vue.component('b-popover', BPopover)

Vue.component('BIconArrowRepeat', BIconArrowRepeat)
Vue.component('BIconXCircle', BIconXCircle)
Vue.component('BIconExclamationCircleFill', BIconExclamationCircleFill)
Vue.component('BIconExclamationCircle', BIconExclamationCircle)
Vue.component('BIconCheckCircle', BIconCheckCircle)
Vue.component('BIconInfoCircle', BIconInfoCircle)
Vue.component('BIconCheck', BIconCheck)
Vue.component('BIconTriangleFill', BIconTriangleFill)
Vue.component('BIconX', BIconX)
Vue.component('BIconXCircle', BIconXCircle)
Vue.component('BIconBoxArrowUpRight', BIconBoxArrowUpRight)
Vue.component('BIconExclamationTriangleFill', BIconExclamationTriangleFill)
Vue.component('BIconExclamationTriangle', BIconExclamationTriangle)
Vue.component('BIconArrowRightShort', BIconArrowRightShort)
Vue.component('BIconPencil', BIconPencil)
Vue.component('BIconPlus', BIconPlus)
Vue.component('BIconArrowLeftShort', BIconArrowLeftShort)
Vue.component('BIconCheckCircleFill', BIconCheckCircleFill)
Vue.component('BIconFolder2Open', BIconFolder2Open)
Vue.component('BIconDownload', BIconDownload)
Vue.component('BIconArrowLeftRight', BIconArrowLeftRight)
Vue.component('BIconTelephone', BIconTelephone)
Vue.component('BIconSearch', BIconSearch)
Vue.component('BIconTrash', BIconTrash)
Vue.component('BIconChevronDown', BIconChevronDown)
Vue.component('BIconFileEarmarkTextFill', BIconFileEarmarkTextFill)
Vue.component('BIconChevronLeft', BIconChevronLeft)
Vue.component('BIconChevronRight', BIconChevronRight)
Vue.component('BIconChevronDown', BIconChevronDown)
Vue.component('BIconChevronUp', BIconChevronUp)
Vue.component('BIconCalendar2EventFill', BIconCalendar2EventFill)
Vue.component('BIconHash', BIconHash)
Vue.component('BIconFullscreen', BIconFullscreen)
Vue.component('BIconTruck', BIconTruck)
Vue.component('BIconBuilding', BIconBuilding)
Vue.component('BIconFiles', BIconFiles)
Vue.component('BIconPerson', BIconPerson)
Vue.component('BIconGear', BIconGear)
Vue.component('BIconGridFill', BIconGridFill)
Vue.component('BIconGraphUp', BIconGraphUp)
Vue.component('BIconCart3', BIconCart3)
Vue.component('BIconBoxArrowUpRight', BIconBoxArrowUpRight)
Vue.component('BIconQuestionSquareFill', BIconQuestionSquareFill)
Vue.component('BIconLayersFill', BIconLayersFill)
Vue.component('BIconListUl', BIconListUl)
Vue.component('BIconFilePersonFill', BIconFilePersonFill)
Vue.component('BIconTelephoneFill', BIconTelephoneFill)
Vue.component('BIconEnvelopeFill', BIconEnvelopeFill)
Vue.component('BIconGeoAltFill', BIconGeoAltFill)
Vue.component('BIconArrowLeft', BIconArrowLeft)
Vue.component('BIconGeoAlt', BIconGeoAlt)
